import { createSlice } from '@reduxjs/toolkit';
import { uploadAndAnalyzeImageAsync, uploadAndAnalyzeImageAsyncBuilder } from './asyncRequests/uploadAndAnalyzeImageAsync';
import { manualAnalyzeTestStripAsyncBuilder, manualAnalyzeTestStripAsync } from './asyncRequests/manualAnalyzeTestStripAsync';
export interface WaterTestStripState {
  data: any; 
  status: 'idle' | 'uploading' | 'processing' | 'completed' | 'failed';
  loading: boolean;
  error: string | null;
  success: boolean;
}

const initialState: WaterTestStripState = {
  data: null,
  status: 'idle',
  loading: false,
  error: null,
  success: false,
}

export const WaterTestStripSlice = createSlice({
  name: 'waterTestStrip',
  initialState,
  reducers: {
    resetWaterTestStripData: (state) => {
      return initialState;
    },
  },
  extraReducers: (builder) => {
    uploadAndAnalyzeImageAsyncBuilder(builder);
    manualAnalyzeTestStripAsyncBuilder(builder);
  },

})

export const WaterTestStripActions = {
  ...WaterTestStripSlice.actions,
  uploadAndAnalyzeImageAsync,
  manualAnalyzeTestStripAsync,
}

export const WaterTestStripReducer = WaterTestStripSlice.reducer;